<template>
  <div v-if="orderData && orderData.orderData && orderData.orderData.hash_pedido">
    <h4 class="checkout-h4 confirmation-subtitle">{{ delivery.name }}</h4>
    <p class="grey--text">{{ delivery.description }}</p>
    <h4 class="checkout-h4 confirmation-subtitle">{{ delivery.subtitle }}</h4>
    <p class="grey--text">{{ delivery.summary }}</p>
    <p class="grey--text text-xs-center">{{ delivery.blockText }}</p>
    <div class="btn-next-step">
      <v-btn
        block
        round
        class="normal-text btn-disabled"
        color="info"
        dark
        depressed
        target="_blank"
      >Ver Ingressos</v-btn>
    </div>
  </div>
  <div v-else-if="orderData && orderData.orderData && !orderData.orderData.hash_pedido">
    <h4 class="checkout-h4 confirmation-subtitle">Seus ingressos foram enviados para o email {{postOrder.email}}</h4>
    <p class="grey--text">Caso não tenha recebido o email, acesse/crie sua conta para acessar seus ingressos.</p>
    <div class="btn-next-step">
      <v-btn
        block
        round
        class="normal-text btn-disabled"
        color="info"
        dark
        depressed
        target="_blank"
        :href="urlSite"
      >Acessar Conta</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      delivery: {
        name: 'Impressão (Nominal)',
        description:
          'Imprima seus ingressos em uma folha A4 e apresente junto com um documento de identidade na entrada principal do evento. Não é necessário passar pela bilheteria.',
        subtitle: 'Identifique os ingressos e imprima',
        summary:
          'Insira seus dados pessoais ou da pessoa que irá utilizar o ingresso para acessar o evento.',
        blockText:
          'Enviaremos um e-mail para você quando os ingressos estarem disponíveis para nomeação!',
      },
    };
  },
  computed: {
    ...mapGetters(['postOrder', 'userProps', 'orderData']),
    urlSite () {
      if (this.userProps) {
      let encode = btoa(JSON.stringify(this.userProps))
      return `https://site.blueticket.com.br/ingressos?register=${encode}`
      } else return 'https://site.blueticket.com.br/ingressos'
    }
  }
};
</script>

<style>
.btn-disabled {
  cursor: not-allowed;
}
</style>
